import { httpMethods } from 'enums';
import { Http } from 'library';
import api from 'api/client';

import * as Endpoints from 'constants/endpoints.constant';

class CustomerHttp {
  static getCustomerList = async () =>
    Http.setMethod(httpMethods.get)
      .setUrl(Endpoints.GET_ALL_CUSTOMERS)
      .setToken(api.getToken())
      .request();

  static getUserProfile = async (userId: any) =>
    Http.setMethod(httpMethods.get)
      .unsetData()
      .setUrl(`${Endpoints.GET_USER_PROFILE}`)
      .setToken(api.getToken())
      .request();
}

export default CustomerHttp;
